import classnames from 'classnames';

import { isDefined } from '@hsp/utilities';

import { Body, Footer, Header } from 'components/table/components';
import { useOnChange } from 'components/table/hooks';
import { useConfiguration } from 'components/table/hooks/configuration';
import { ITableProps } from 'types/components/table';

function DataTable<TData, TValue = unknown>({
  allowSortRemoval = false,
  columns,
  dataSource,
  emptyMessage = 'No data found',
  enableExpanding = false,
  enableGlobalFilter = false,
  enableSorting = true,
  enablePaging = true,
  getRowCanExpand,
  getRowId,
  onCollapsed,
  onExpanded,
  onRowSelected,
  onPage,
  onSort,
  renderSubComponent,
  showFooter = false,
  showHeader = true,
  sorts,
  striped = true,
}: ITableProps<TData, TValue>) {
  const { sort, table, total } = useConfiguration({
    allowSortRemoval,
    columns,
    dataSource,
    enableExpanding,
    enableGlobalFilter,
    enablePaging,
    enableSorting,
    getRowCanExpand,
    getRowId,
    onPage,
    sorts,
  });

  useOnChange(table, total, sort, onPage, sorts);

  return (
    <table className={classnames('table', { 'table-hover': isDefined(onRowSelected), 'table-striped': striped })}>
      <Header
        enabled={showHeader}
        onSort={onSort}
        table={table}
      />
      <Body
        emptyMessage={emptyMessage}
        onCollapsed={onCollapsed}
        onExpanded={onExpanded}
        onRowSelected={onRowSelected}
        renderSubComponent={renderSubComponent}
        table={table}
      />
      <Footer
        enabled={showFooter}
        table={table}
      />
    </table>
  );
}

export default DataTable;
